import { render } from "./detail.vue?vue&type=template&id=30d897cf&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=30d897cf&lang=less&scoped=true"
import "./detail.vue?vue&type=style&index=1&id=30d897cf&scoped=true&lang=less"

import exportComponent from "E:\\project\\zjam-ctid\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30d897cf"]])

export default __exports__